import type { MouseEvent } from 'react';

import type { ProductStyle } from 'types/cloudCatalog';
import type { SelectedSizing } from 'types/product';
import type { FormattedProductBundle } from 'reducers/detail/productDetail';
import { pluralize } from 'helpers/index';
import { hasAlternativeStyles } from 'helpers/ProductUtils';
import useMartyContext from 'hooks/useMartyContext';
import { OutOfStockAltList } from 'components/productdetail/OutOfStock/OutOfStockAltList';

interface OutOfStockAlternativesProps {
  detail: FormattedProductBundle;
  onStyleChange?: (e: MouseEvent<HTMLButtonElement>) => void;
  productStyles: Record<string, ProductStyle>;
  selectedSizing: SelectedSizing;
}

export const OutOfStockAltContainer = ({ detail, onStyleChange, productStyles, selectedSizing }: OutOfStockAlternativesProps) => {
  const { testId } = useMartyContext();
  const { sizing } = detail;
  const { dimensions } = sizing;

  const [hasAlts, altCount] = hasAlternativeStyles({ productStyles, selectedSizing, sizing });

  if (!hasAlts || !dimensions.length || !dimensions[0]) {
    return null;
  }

  const { id, rank } = dimensions[0];
  const dimId = `d${id}`;
  const currentSizedId = rank === '1' ? selectedSizing[dimId] : undefined;

  if (!currentSizedId) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4" data-test-id={testId('otherStylesInSizeContainer')}>
      <p className="text-lg text-primary">
        View {altCount} available {pluralize('color', altCount)} in your size
      </p>
      <div className="flex w-full gap-4 overflow-x-auto">
        <OutOfStockAltList
          detail={detail}
          onStyleChange={onStyleChange}
          productStyles={productStyles}
          selectedSizing={selectedSizing}
          sizeId={currentSizedId}
        />
      </div>
    </div>
  );
};
